//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Timeline from 'timeline-vuejs';
export default {
  name: 'About',
  components: {
    Timeline: Timeline
  },
  data: function data() {
    return {
      messageWhenNoItems: 'There arent commits',
      members: [],
      dataTimeline: [],
      page: 0
    };
  },
  created: function created() {
    this.loadCommits();
    this.loadMembers();
  },
  methods: {
    loadMore: function loadMore() {
      this.page++;
      this.loadCommits();
    },
    loadCommits: function loadCommits() {},
    loadMembers: function loadMembers() {}
  }
};